import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { UserContextService } from '../../core/services/user-context.service';
import { AuthService } from '../../core/services/auth.service';
import { LayoutService } from '../../core/services/layout.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
  userContext = inject(UserContextService);
  authService = inject(AuthService);
  layoutService = inject(LayoutService);
  private router = inject(Router);

  isFinanceOpen = signal<boolean>(false);

  toggleFinanceSubmenu() {
    this.isFinanceOpen.update(v => !v);
  }

  isFinanceRouteActive(): boolean {
    return this.router.url.startsWith('/duplicatas');
  }

  onLinkClick() {
    this.layoutService.closeMobileSidebar();
  }
}
